<template>
  <div class="meal-container">
    <div class="meal-header">
      <label>开餐日期：</label>
      <input type="datetime-local" v-model="mealDate" @change="updateMealDate" />
    </div>
    <div class="qr-code-container" v-if="qrCodeBase64">
      <img :src="'data:image/png;base64,' + qrCodeBase64" alt="QR Code" />
    </div>
    <div class="meal-buttons">
      <label>核销二维码：</label>
      <button
        class="meal-button"
        :class="{ active: mealType === '早餐' }"
        @click="selectMeal('早餐')"
      >
        早餐
      </button>
      <button
        class="meal-button"
        :class="{ active: mealType === '午餐' }"
        @click="selectMeal('午餐')"
      >
        午餐
      </button>
      <button
        class="meal-button"
        :class="{ active: mealType === '晚餐' }"
        @click="selectMeal('晚餐')"
      >
        晚餐
      </button>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  data() {
    return {
      mealDate: dayjs().format('YYYY-MM-DDTHH:mm:ss'), // 默认日期和时间为当前时间
      qrCodeBase64: '', // 用于存储二维码的Base64编码
      mealType: '', // 当前选择的餐次类型
      intervalId: null, // 定时任务ID
    };
  },
  methods: {
    selectMeal(mealType) {
      this.mealType = mealType;
      this.fetchQRCode();
      // 设置定时任务，每15秒获取一次二维码
      if (!this.intervalId) {
        this.intervalId = setInterval(this.fetchQRCode, 15000);
      }
    },
    fetchQRCode() {
      if (!this.mealType) {
        this.$message.warning('请选择餐次类型');
        return;
      }
      const currentTime = dayjs().format('YYYY-MM-DDTHH:mm:ss');
      this.mealDate = currentTime; // 更新当前时间
      this.$axios.post('/api/show_qrCode', {
        time: this.mealDate,
        leixing: this.mealType,
      })
        .then(response => {
          this.qrCodeBase64 = response.data.data;
        })
        .catch(error => {
          console.error('获取二维码失败', error);
          this.$message.error('获取二维码失败，请稍后再试');
          this.qrCodeBase64 = '';
        });
    },
    updateMealDate() {
      this.mealDate = dayjs(this.mealDate).format('YYYY-MM-DDTHH:mm:ss');
    },
    clearIntervals() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  },
  beforeDestroy() {
    this.clearIntervals();
  }
};
</script>

<style scoped>
.meal-container {
  padding: 20px;
  background-color: #f5f5f5;
}

.meal-header {
  margin-bottom: 20px;
  margin-left: 200px;
}

.meal-header input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 20%;
}

.qr-code-container {
  margin: 20px 0;
  display: flex;
  justify-content: center;
}

.qr-code-container img {
  width: 200px;
  height: 200px;
}

.meal-buttons {
  display: flex;
  gap: 10px;
  margin-left: 200px;
}

.meal-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: white;
  color: black;
  margin-left: 5px;
}

.meal-button.active {
  background-color: #cb9e4f;
  color: white;
}

.meal-button:nth-child(2):not(.active) {
  background-color: white;
}

.meal-button:nth-child(3):not(.active) {
  background-color: white;
}
</style>